export default "__VITE_ASSET__DVBEkxwn__"